import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../../core/Buttons';
import Loading from '../../core/Loading';
import { StyledModal, StyledInput, StyledDniInfo } from './style';

const ModalPassword = ({
  clickCloseIcon,
  action,
  labelTitle,
  labelContent,
  labelPlaceHolder,
  labelPasswordIncorrect,
  errorPassword,
  labelButton,
  loadingInModal,
  errorDni
}) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [isPasswordCorrect, setIsPasswordCorrect] = useState(!errorPassword);
  const [dni, setDni] = useState('');
  const [isDniCorrect, setIsDniCorrect] = useState(!errorDni);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    console.log(loadingInModal);
    setIsPasswordCorrect(!errorPassword);
    setIsDniCorrect(!errorDni);
  }, []);

  return (
    <StyledModal
      title={labelTitle || 'CONFIRMA TU CONTRASEÑA'}
      clickCloseIcon={clickCloseIcon}
    >
      {loadingInModal ? (
        <div style={{ minHeight: '200px' }}>
          <Loading />
        </div>
      ) : (
        <>
          <p>
            {labelContent || 'Introduce tu contraseña para iniciar la descarga'}
          </p>

          <StyledInput
            autoComplete="new-password"
            type="password"
            placeholder={labelPlaceHolder || 'Contraseña'}
            error={
              !isPasswordCorrect
                ? labelPasswordIncorrect || 'Contraseña incorrecta'
                : undefined
            }
            onChange={event => {
              const value = event;
              setCurrentPassword(value);
              setIsButtonDisabled(!value || !dni);
              setIsPasswordCorrect(true);
            }}
          />

          <p> Introduce DNI</p>
          <StyledInput
            autoComplete="dni"
            type="text"
            placeholder="DNI"
            error={!isDniCorrect ? 'El DNI es incorrecto' : undefined}
            onChange={event => {
              const value = event;
              setDni(value);
              setIsButtonDisabled(!currentPassword || !value);
            }}
          />

          <StyledDniInfo>
            IMPORTANTE: La contraseña para abrir el pdf descargado será el DNI
            del trabajador sin ceros por la izquierda y con la letra mayúscula.
          </StyledDniInfo>

          <Button
            secondary
            disabled={isButtonDisabled}
            onClick={() => action(currentPassword, dni)}
          >
            {labelButton || 'DESCARGAR'}
          </Button>
        </>
      )}
    </StyledModal>
  );
};

ModalPassword.propTypes = {
  action: PropTypes.func,
  clickCloseIcon: PropTypes.func,
  errorPassword: PropTypes.bool
};

export default ModalPassword;
